/* eslint-disable camelcase */
import { getAllRooms } from 'api/room';

export default async function fetchAllRooms(query = {}) {
    const rooms = [];

    const { data: { data, meta: { last_page } } } = await getAllRooms(query);

    rooms.push(...data);

    for (let current_page = 2; current_page <= last_page; current_page++) {
        const { data: { data } } = await getAllRooms({
            ...query,
            page: current_page
        });

        rooms.push(...data);
    }

    return rooms;
}
